"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _lodash = _interopRequireDefault(require("lodash.throttle"));
var _default = function _default(_ref) {
  var callback = _ref.callback,
    resetCallback = _ref.resetCallback,
    _ref$scrollThreshold = _ref.scrollThreshold,
    scrollThreshold = _ref$scrollThreshold === void 0 ? 10 : _ref$scrollThreshold,
    _ref$stateVars = _ref.stateVars,
    stateVars = _ref$stateVars === void 0 ? [] : _ref$stateVars;
  (0, _react.useEffect)(function () {
    var handleScroll = (0, _lodash["default"])(function () {
      if (typeof window !== 'undefined' && window.pageYOffset > scrollThreshold) {
        callback();
      } else if (resetCallback) {
        resetCallback();
      }
    }, 100);
    window.addEventListener('scroll', handleScroll);
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, stateVars);
};
exports["default"] = _default;